import React, { useState } from "react";
import Modal from "react-modal";
import { Loading } from "./LoadingBig";
import clsx from "clsx";
Modal.setAppElement("body");
const ProjectModals = ({ setModalIsOpen, modalIsOpen, workdata }) => {
  const [iframeStatus, setIframeStatus] = useState("loading");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const handleIframeLoad = (event) => {
    const iframe = event.currentTarget;
    iframe.style.display = "block";
    setIframeStatus("loaded");
  };
  function closeModal() {
    setIframeStatus("loading");
    setModalIsOpen(false);
  }

  function afterOpenModal() {}
  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <>
        {workdata === undefined ? (
          "Error"
        ) : (
          <>
            {iframeStatus === "loading" ? <Loading /> : null}

            <iframe
              title="work"
              src={workdata}
              onLoad={handleIframeLoad}
              className={clsx(
                "transition-all duration-[1000ms] ease-in-out transform w-[80vw] h-screen max-w-6xl inset-0 ",
                iframeStatus === "loading" ? "hidden opacity-0" : "opacity-100"
              )}
            />
          </>
        )}
      </>
    </Modal>
  );
};

export default ProjectModals;
